import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-popup container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tips_contianer" }, null, -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card_header" }
const _hoisted_5 = { class: "header primary-text" }
const _hoisted_6 = { class: "card_body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "header")
            ]),
            _createVNode(_component_base_icon, {
              class: "icon",
              name: "close",
              color: _ctx.primaryColor,
              onClick: _ctx.close
            }, null, 8, ["color", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}